import React from 'react';
import { useGetDronesQuery } from '@src/core/features/drone/redux';
import { ArcSocketContext, ChannelResponseEnum } from '@src/core/socket';
import { PAGINATION_DEFAULT_SIZE } from '@src/core/config';

export const usePaginatedDrones = () => {
  const [page, setPage] = React.useState(0);
  const { subscribe, unsubscribe } = React.useContext(ArcSocketContext);

  const { data, isLoading, isFetching, refetch } = useGetDronesQuery();

  React.useEffect(() => {
    subscribe(ChannelResponseEnum.UPDATE_DRONES, () => refetch());
    return () => unsubscribe(ChannelResponseEnum.UPDATE_DRONES);
  }, [refetch, subscribe, unsubscribe]);

  const allDrones = data?.data ?? [];
  const totalCount = data?.totalCount ?? allDrones.length;
  const size = PAGINATION_DEFAULT_SIZE;

  const start = page * size;
  const drones = React.useMemo(
    () => allDrones.slice(start, start + size),
    [allDrones, start, size],
  );

  const handlePageChange = React.useCallback((newPage: number) => {
    setPage(newPage);
  }, []);

  return {
    allDrones,
    drones,
    isLoading,
    isFetching,
    refetch,
    pagination: {
      page,
      size,
      totalCount,
      onPageChange: handlePageChange,
    },
  };
};
